<template>
  <div class="about text-xs-center">
    <v-dialog
      v-model="dialog"
      persistent
      width="550"
    >
      <v-btn
        slot="activator"
        color="red lighten-2"
        dark
      >
        Click Me
      </v-btn>

      <v-card>
        <v-card-title
          class="headline"
          :class="darkTheme ? '' : 'grey lighten-2'"
          primary-title
        >
          Interactive Floorplans
        </v-card-title>

        <v-card-text>
            <div class="mx-4">
              
              <p class="mt-4"><strong>Interactive Floorplans</strong> is brought to you by University Information Technology Services.</p>
              <div align="center"><iframe width="80%" src="https://www.youtube.com/embed/C-4aRXmrXsY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
              <p class="" align="center">See Every Feature (4 mins)</p>

              <p class="">For any questions related to Space Management, Space Requests or assignments, please visit the <a href="http://ssm.arizona.edu" target="_blank" class="redlink">Space Strategy & Mgmt Website</a></p>
              <p class="">Interactive Floorplans is always under development. Please let us know what feature or improvement you wish for.</p>
              <p class="">For any questions related to the technology used for this service, contact <a href="mailto:drennen@arizona.edu?subject=Interactive%20Floorplans" class="redlink">Drennen Brown</a> - Director Information Technology</p>
              <p class="">Visit <a href="http://maps.arizona.edu" target="_blank" class="redlink">maps.arizona.edu</a> to see more maps powered by the <a href="https://maps.arizona.edu/enterprisegis/" target="_blank" class="redlink">UA Enterprise GIS</a> and other interior mapping tools.</p>
              <v-divider></v-divider>
            </div>
        </v-card-text>

        

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="clickOK"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'About',
    data () {
      return {
        dialog: true
      }
    },

    methods: {
      clickOK () {
        this.$router.go('-1')
        this.dialog = false
      },
        ...mapGetters([   'colorizedLegend']),
    },

    computed: {
      ...mapState({ darkTheme: state => state.ui.darkTheme })
    },
  }

</script>

<style>

.about {
  z-index: 2;
}

.aboutPDClogo {
  margin-top: 20px;
  margin-bottom: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/About.vue